import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/modx': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M356 241.8l36.7 23.7v214.5l-133-83.8zM440 75l-83.2 134.3-153.5-96.5 23-37.8h213.7zM351 217.8l-249.8 57.7-46-29v-214.5zM97 294.2l249.7-57.7-125 200.5h-213.7z'
      }
    ]
  }
})
